import { render, staticRenderFns } from "./RiskSurveyStockDesc.vue?vue&type=template&id=acc45574&"
import script from "./RiskSurveyStockDesc.vue?vue&type=script&lang=js&"
export * from "./RiskSurveyStockDesc.vue?vue&type=script&lang=js&"
import style0 from "./RiskSurveyStockDesc.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports